// Hook das telas para o catálogo de idiomas (global/languages). Assina o doc,
// então uma mudança feita pelo master em Empresa → Idiomas chega às telas
// abertas sem recarregar. Enquanto o doc não carrega, devolve o catálogo padrão
// — nenhum select nasce vazio.
import { useEffect, useState } from "react";
import {
  DEFAULT_LANGUAGE_CONFIG,
  subscribeLanguageConfig,
} from "./languageConfig";

export default function useLanguageConfig() {
  const [config, setConfig] = useState(DEFAULT_LANGUAGE_CONFIG);

  useEffect(() => {
    const unsub = subscribeLanguageConfig(setConfig);
    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, []);

  return config;
}
